import styled from 'styled-components'
import { giphyAqua, giphyLightBlue } from '../../styles/colors'

type GradientTextProps = {
    gradient?: string
}

export const GradientText = styled.span<GradientTextProps>`
    background: ${({ gradient }) => gradient || `linear-gradient(to right, ${giphyLightBlue}, ${giphyAqua})`};
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    font-weight: bold;
    margin: 2px 0;
`
